import { Directive, Input, ElementRef, Renderer2, OnInit } from '@angular/core';

// SERVICES
import { EnvironmentUtilService } from '../services/util/environment-util.service';

@Directive({
  selector: '[lumRfqThumbnailUrl]',
})
export class RfqThumbnailUrlDirective implements OnInit {
  @Input('lumRfqThumbnailUrl')
  rfq :any;

  constructor(
    private el :ElementRef,
    private renderer :Renderer2,
    private environmentUtilService :EnvironmentUtilService,
  ) {}

  environment = this.environmentUtilService.getEnvironment();

  ngOnInit() {
    this.init();
  }

  private init() :void {
    this.renderer.setProperty(
      this.el.nativeElement,
      'src',
      this.getItemImage(this.rfq) || '/assets/images/no_image_placeholder.jpg',
    );
  }

  private getItemImage(item :any) :string {
    const rfqAttachments = item?.rfqAttachments || item?.rfq_attachments || [];
    if (
      rfqAttachments?.[0]?.filetype === 'image/jpeg' ||
      rfqAttachments?.[0]?.filetype === 'image/png'
    ) {
      return this.environment.url + '/api/file?f=' + rfqAttachments[0]?.thumburl;
    }

    if (
      item?.attachments?.[0]?.filetype === 'image/jpeg' ||
      item?.attachments?.[0]?.filetype === 'image/png'
    ) {
      return this.environment.url + '/api/file?f=' + item.attachments[0]?.thumburl;
    }

    if (item.images?.length && item.images[0]?.thumbnail_url) {
      return this.environment.url + '/api/file?f=' + item.images[0].thumbnail_path;
    }

    return item.photo;
  }
}
